import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SalesProductsService } from './service/sales-products.service';
import { SalesProductsEffects } from './state/sales-products/sales-products.effects';
import { SalesProductsFacade } from './state/sales-products/sales-products.facade';
import * as fromSalesProducts from './state/sales-products/sales-products.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromSalesProducts.SALES_PRODUCTS_FEATURE_KEY, fromSalesProducts.salesProductsReducer),
    EffectsModule.forFeature([SalesProductsEffects]),
  ],
  providers: [SalesProductsFacade, SalesProductsService],
})
export class SharedDataAccessSalesProductsModule {}
